import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { GlobalService } from '../../../core/_infrastructure/classes/services/global.service';
import { GrupoTaricFrSanidadExteriorService } from './grupotaricfrsanidadexterior.service';
import { GrupoTaricFrSanidadExteriorViewModel } from './grupotaricfrsanidadexterior.types';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';

import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { Tc } from '../../../core/_infrastructure/types/common';
import { DecimalPipe } from '@angular/common';

@Component({
    selector: 'app-grupotaricfrsanidadexterior-edit',
    templateUrl: './grupotaricfrsanidadexterior-edit.component.html',
})
export class GrupoTaricFrSanidadExteriorEditComponent extends ComponentBase implements OnInit {
    editMode: boolean;
    editTitle: string = 'Nuevo';
    grupotaricfrsanidadexterior: GrupoTaricFrSanidadExteriorViewModel;
    listGruposPaisesFr: Tc[];
    visibilitySpinner: boolean = false;

    constructor(
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private fb: UntypedFormBuilder,
        private globalService: GlobalService,
        public decimalPipe: DecimalPipe,
        private grupoTaricFrSanidadExteriorService: GrupoTaricFrSanidadExteriorService,
        protected notificationService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
    ) {
        super(authService, notificationService, exceptionHandler);

        this.grupotaricfrsanidadexterior = new GrupoTaricFrSanidadExteriorViewModel();
    }

    ngOnInit() {
        this.globalService.getGrupoPaisesFr().subscribe(res => {
            this.listGruposPaisesFr = res;
        });

        this.createForm();

        let id = +this.activatedRoute.snapshot.params['id'];

        if (id) {
            this.editMode = true;
            this.editTitle = 'Editar';

            this.grupoTaricFrSanidadExteriorService.getGrupoTaricFrSanidadExterior(id).subscribe(result => {
                this.grupotaricfrsanidadexterior = result;
                this.updateForm();
            });
        }
    }

    createForm() {
        this.form = this.fb.group({
            Descripcion: ['', Validators.required],
            CodigoTaric: ['', Validators.compose([Validators.required, Validators.maxLength(10), Validators.minLength(4)])],
            IdGrupoPaisFr: [null, Validators.required],
            PorcentajeFisica: [null, Validators.compose([Validators.required, Validators.maxLength(5), Validators.max(100)])],
            PorcentajeLab: [null, Validators.compose([Validators.maxLength(5), Validators.max(100)])],
            Riesgo: '',
            Regulacion: '',
            Activo: [true, Validators.required],
            AvisoChedD: [false, Validators.required],
        });
    }

    updateForm() {
        this.form.setValue({
            Descripcion: this.grupotaricfrsanidadexterior.Descripcion,
            CodigoTaric: this.grupotaricfrsanidadexterior.CodigoTaric,
            IdGrupoPaisFr: this.grupotaricfrsanidadexterior.IdGrupoPaisFr,
            PorcentajeFisica: this.decimalPipe.transform(this.grupotaricfrsanidadexterior.PorcentajeFisica, '1.2-2', 'es'),
            PorcentajeLab: this.decimalPipe.transform(this.grupotaricfrsanidadexterior.PorcentajeLab, '1.2-2', 'es'),
            Riesgo: this.grupotaricfrsanidadexterior.Riesgo,
            Regulacion: this.grupotaricfrsanidadexterior.Regulacion,
            Activo: this.grupotaricfrsanidadexterior.Activo,
            AvisoChedD: this.grupotaricfrsanidadexterior.AvisoChedD,
        });

        if (this.grupotaricfrsanidadexterior.PorcentajeFisica === 100) {
            this.form.patchValue({
                PorcentajeFisica: this.decimalPipe.transform(this.grupotaricfrsanidadexterior.PorcentajeFisica, '1.0-0', 'es'),
            });
        }

        if (this.grupotaricfrsanidadexterior.PorcentajeLab === 100) {
            this.form.patchValue({
                PorcentajeLab: this.decimalPipe.transform(this.grupotaricfrsanidadexterior.PorcentajeLab, '1.0-0', 'es'),
            });
        }
    }

    onSubmit() {
        this.submitted = true;

        if (!this.form.valid) {
            this.addErrorMessage('Revise los datos');
            return;
        }

        this.visibilitySpinner = true;

        let porcentajeFisicaFormat =
            this.form.value.PorcentajeFisica != null ? this.form.value.PorcentajeFisica.replace('.', '').replace(',', '.') : this.form.value.PorcentajeFisica;
        let porcentajeLabFormat =
            this.form.value.PorcentajeLab != null ? this.form.value.PorcentajeLab.replace('.', '').replace(',', '.') : this.form.value.PorcentajeLab;

        if (porcentajeFisicaFormat > 100) {
            this.addErrorMessage('El Porcentaje Física no puede ser superior a 100');
            this.visibilitySpinner = false;
            return;
        }

        if (porcentajeLabFormat > 100) {
            this.addErrorMessage('El Porcentaje Laboratorio no puede ser superior a 100');
            this.visibilitySpinner = false;
            return;
        }

        let grupotaricfrsanidadexterior = new GrupoTaricFrSanidadExteriorViewModel();

        grupotaricfrsanidadexterior.Descripcion = this.form.value.Descripcion;
        grupotaricfrsanidadexterior.CodigoTaric = this.form.value.CodigoTaric;
        grupotaricfrsanidadexterior.IdGrupoPaisFr = this.form.value.IdGrupoPaisFr;
        grupotaricfrsanidadexterior.PorcentajeFisica = porcentajeFisicaFormat;
        grupotaricfrsanidadexterior.PorcentajeLab = porcentajeLabFormat;
        grupotaricfrsanidadexterior.Riesgo = this.form.value.Riesgo;
        grupotaricfrsanidadexterior.Regulacion = this.form.value.Regulacion;
        grupotaricfrsanidadexterior.Activo = this.form.value.Activo;
        grupotaricfrsanidadexterior.AvisoChedD = this.form.value.AvisoChedD;

        grupotaricfrsanidadexterior.Id = this.grupotaricfrsanidadexterior.Id;

        if (this.editMode) {
            this.grupoTaricFrSanidadExteriorService.editGrupoTaricFrSanidadExterior(grupotaricfrsanidadexterior).subscribe({
                next: () => {
                    this.addSuccessMessage('Grupo Taric FR Higiene modificado correctamente');
                    this.onBack();
                    this.visibilitySpinner = false;
                },
                error: error => {
                    this.catchServerError(error);
                    this.visibilitySpinner = false;
                },
            });
        } else {
            this.grupoTaricFrSanidadExteriorService.createGrupoTaricFrSanidadExterior(grupotaricfrsanidadexterior).subscribe({
                next: () => {
                    this.addSuccessMessage('Grupo Taric FR Higiene añadido correctamente');
                    this.onBack();
                    this.visibilitySpinner = false;
                },
                error: error => {
                    this.catchServerError(error);
                    this.visibilitySpinner = false;
                },
            });
        }
    }

    //emarti69: Función para que si el usuario escribe '100' en los porcentajes, no se le deje escribir ningún dígito más
    onPorcentajeInput(event: Event, controlName: string) {
        const input = event.target as HTMLInputElement;
        let value = input.value.trim();

        if (value.startsWith('100')) {
            if (value !== '100') {
                value = '100';
                input.value = value;
                this.form.controls[controlName].setValue(value, { emitEvent: false });
            }
        }
    }

    //Para eliminar la validación del error de Taric Duplicado al cambiar el Grupo Pais FR
    onSelectGrupoPaisesFr() {
        const control = this.form.get('CodigoTaric');
        if (!control) return;

        const errores = control.errors;

        if (!errores || !Array.isArray(errores.customErrors)) return;

        // Filtramos los errores, eliminando el que tenga key = 'taricpais_duplicated'
        const nuevosErrores = errores.customErrors.filter((e: any) => e.key !== 'taricpais_duplicated');

        if (nuevosErrores.length === 0) {
            // Si ya no quedan errores personalizados, eliminamos todo el error
            control.setErrors(null);
        } else {
            // Si quedan otros errores, actualizamos solo esa parte
            control.setErrors({ customErrors: nuevosErrores });
        }

        control.markAsTouched(); // actualiza el estado visual
    }

    onBack() {
        this.router.navigate(['/mantenimiento/frecuenciareducida/grupostaricfrsanidadexterior']);
    }
}
